import PropTypes from "prop-types";
import React from "react";
import { multilanguage, changeLanguage } from "redux-multilanguage";
import { connect } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { changeCurrency } from "../../../../redux/actions/currencyActions";
import { CURRENCIES } from "../../../../utils/constants/currencies";
import { LANGUAGE_LABELS, getAvailableLanguages, getDefaultLanguage, changeLanguageUrl } from "../../../../utils/languages";

const MobileLangCurrChange = ({ currency, changeCurrency, currentLanguageCode, dispatch }) => {
    const history = useHistory();
    const location = useLocation();
    const siteData = useSelector((state) => state.siteData);
    const availableLanguages = getAvailableLanguages(siteData);
    const defaultLanguage = getDefaultLanguage(siteData);

    const changeLanguageTrigger = (e) => {
        const languageCode = e.target.value;
        dispatch(changeLanguage(languageCode));
        changeLanguageUrl(location, history, languageCode, defaultLanguage, availableLanguages);
    };

    const changeCurrencyTrigger = (e) => {
        const currencyName = e.target.value;
        changeCurrency(currencyName);
    };

    const closeMobileMenu = () => {
        const offcanvasMobileMenu = document.querySelector("#offcanvas-mobile-menu");
        offcanvasMobileMenu.classList.remove("active");
    };

    return (
        <div className="mobile-menu-middle">
            <div className="lang-curr-style">
                <span className="title mb-2">Choose Language </span>
                <select
                    value={currentLanguageCode}
                    onChange={(e) => {
                        changeLanguageTrigger(e);
                        closeMobileMenu();
                    }}
                >
                    {availableLanguages.map((lang) => (
                        <option key={lang} value={lang}>
                            {LANGUAGE_LABELS[lang]}
                        </option>
                    ))}
                </select>
            </div>
            <div className="lang-curr-style">
                <span className="title mb-2">Choose Currency</span>
                <select
                    value={currency.currencyName}
                    onChange={(e) => {
                        changeCurrencyTrigger(e);
                        closeMobileMenu();
                    }}
                >
                    {Object.keys(CURRENCIES).map((currency) => (
                        <option key={currency} value={currency}>
                            {currency}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    );
};

MobileLangCurrChange.propTypes = {
    changeCurrency: PropTypes.func,
    currency: PropTypes.object,
    currentLanguageCode: PropTypes.string,
    dispatch: PropTypes.func,
};

const mapStateToProps = (state) => {
    return {
        currency: state.currencyData,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeCurrency: (currencyName) => {
            dispatch(changeCurrency(currencyName));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(multilanguage(MobileLangCurrChange));
